import React from "react";
import Notifications from "./notifications";
import ProjectList from "../projects/projectList";
import { connect } from "react-redux";
import { firebaseConnect, firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Redirect } from "react-router-dom";
class DashBoard extends React.Component {
  render() {
    const { tasks, auth } = this.props;

    const data = this.props.firestore.tasks;
    if (!auth.uid) {
      return <Redirect to="/signin" />;
    } else {
      return (
        <div className="dashboard container">
          <div className="row">
            <div className="col s12 m6 ">
              <ProjectList tasks={tasks} />
            </div>
            <div className="col s12 m5 offset -m1">
              <Notifications />
            </div>
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    tasks: state.firestore.ordered.tasks,
    auth: state.firebase.auth,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([{ collection: "tasks" }])
)(DashBoard);
